import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

export interface fileDetails {
  referenceId: string;
  businessName: string;
  contactName: string;
  contactPhone: string;
  contactEmail: string;
  files: File[];
  submittedDate: Date | undefined;
  caseActivityKey: string;
  validateEmail: string;
  emailCode: BigInteger;
}

@Injectable({
  providedIn: 'root'
})
export class FileServiceService {

  referenceFileDetails: fileDetails;
  pageIndex: number = 0;
  authenticatedEmail : string | null = null;
  visitedPages: Set<string> = new Set();

 constructor(private route: Router) {

  const cached = sessionStorage.getItem('visitedPages');
  this.visitedPages = cached ? new Set(JSON.parse(cached)) : new Set();

  this.referenceFileDetails = {
    referenceId: this.getCache("referenceId"),
    businessName: '',
    contactName: '',
    contactPhone: '',
    contactEmail: '',
    files: [],
    submittedDate: undefined,
    caseActivityKey:'',
    validateEmail:'',
    emailCode: undefined
  };

  this.pageIndex = 0;
}

  setPageVisited(path: string) {
    this.visitedPages.add(path);
    sessionStorage.setItem('visitedPages', JSON.stringify(Array.from(this.visitedPages)));
  }
  hasVisited(path: string): boolean {
    return this.visitedPages.has(path);
  }
  clearVisitedPages() {
    this.visitedPages.clear();
    sessionStorage.removeItem('visitedPages');
  }

  setCacheForitems(items: any[]) {
    items.forEach(element => {
      if (element.value !== undefined && element.value !== null) {
        sessionStorage.setItem(element.id, JSON.stringify(element.value));
      } else {
        sessionStorage.removeItem(element.id);
      }
    });
  }

  getCache(id: string) {
    const item = sessionStorage.getItem(id);

    if (!item || item === "undefined") {
      return null;
    }

    try {
      return JSON.parse(item);
    } catch (e) {
      console.error(`Error parsing cache item "${id}":`, e);
      sessionStorage.removeItem(id); 
      return null;
    }
  }


  clearCache()
  {
    sessionStorage.clear();
    this.clearVisitedPages(); 
    this.pageIndex = 0;
  }

  reset() {
    this.referenceFileDetails = {
      referenceId: '',
      businessName: '',
      contactName: '',
      contactPhone: '',
      contactEmail: '',
      files: [],
      submittedDate: undefined,
      caseActivityKey: '',
      validateEmail:'',
      emailCode: undefined
    };
    this.pageIndex = 0;
  }

  navigateTo(path: string) {
    this.route.navigate([path]);
  }

   setAuthenticatedEmail(email: string) {
    this.authenticatedEmail = email;
  }

  isEmailAuthenticated(email: string): boolean {
    return this.authenticatedEmail === email;
  }
}
